import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of, tap } from 'rxjs';
import { PraticheApiService } from './pratiche-api.service';
import { PraticaUtente, RichiestaPraticaStatusBE } from '../../shared/models/pratiche';
import { LocalStorageService } from '../local-storage.service';

const ACCEPTED_STATUSES: RichiestaPraticaStatusBE[] = [
  RichiestaPraticaStatusBE.RICHIESTA_ACCETTATA,
  RichiestaPraticaStatusBE.VOUCHER_ASSEGNATI,
  RichiestaPraticaStatusBE.VOUCHER_CONSEGNATI,
];

@Injectable({
  providedIn: 'root'
})
export class GlobalManagerPraticheService {

  praticheMensa$ = new BehaviorSubject<PraticaUtente[]>([]);

  constructor(
    private praticheApiService: PraticheApiService,
    private localStorageService: LocalStorageService,
  ) {}

  loadPraticheMensa$(): Observable<PraticaUtente[]> {
    const cf = this.localStorageService.getAnagrafiche()?.[0]?.codiceFiscale;
    if (!cf) {
      this.praticheMensa$.next([]);
      return of([]);
    }

    return this.praticheApiService.getPratiche(cf).pipe(
      map(page => {
        return (page.content ?? [])
          .filter(p => p.codiceTipoPratica?.toUpperCase().includes('MENSA'));
      }),
      tap(pratiche => this.praticheMensa$.next(pratiche)),
    );
  }

  get praticheMensa(): PraticaUtente[] {
    return this.praticheMensa$.getValue();
  }

  get hasAlmenoUnaAccettata(): boolean {
    return this.praticheMensa.some(p => ACCEPTED_STATUSES.includes(p.statusRichiesta!));
  }

  get hasPratiche(): boolean {
    return this.praticheMensa.length > 0;
  }

  reset() {
    this.praticheMensa$.next([]);
  }
}
